import { cva } from 'class-variance-authority';

/**
 * The panel's button, in three jobs.
 *
 * Everything the three share — the layout, the focus ring, the transition —
 * is the base; a variant only says what makes it different.
 */
export const devToolsButtonVariants = cva(
  'inline-flex items-center gap-1.5 border bg-transparent font-medium transition-colors focus:outline-none focus-visible:ring-2',
  {
    variants: {
      variant: {
        default:
          'rounded-[7px] border-zinc-800 px-2.5 py-1 text-[11.5px] text-zinc-300 hover:bg-zinc-800 hover:text-zinc-200 focus-visible:ring-emerald-400/40',
        destructive:
          'rounded-[7px] border-red-800 px-2.5 py-1 text-[11.5px] text-red-400 hover:bg-red-950 focus-visible:ring-red-400/40',
        export:
          'rounded-md border-zinc-800 px-2 py-1 text-[11px] text-zinc-300 hover:border-emerald-800 hover:text-emerald-400 focus-visible:ring-emerald-400/40',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);
